import { isArray, isObject, transform } from 'lodash'

// lodash.snakeCase режет цифры: mlServerS3Bucket → ml_server_s_3_bucket, бэк такое поле не видит.
const snakeCaseKey = (key: string) =>
  key
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/-/g, '_')
    .toLowerCase()

export const toSnakeCase = <SnakeCase extends object>(obj: any): SnakeCase =>
  transform(obj, (acc: any, value, key, target) => {
    const snakeKey = isArray(target) ? key : snakeCaseKey(key as string)
    acc[snakeKey] = isObject(value) ? toSnakeCase(value) : value
  })
